import Vue from 'vue'
const infiniteScroll = require('vue-infinite-scroll')
Vue.use(infiniteScroll)